import { ILoginState } from '@/models/ILoginState'
import Heading from '../Heading'
import { Container } from '@/components/Container'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-regular-svg-icons'
import { faLocationDot } from '@fortawesome/free-solid-svg-icons'

interface IResourceArticle {
	heading: string
	id: number
	introduction: string
	updatedDate: string
    dateOfEvent: string
	address?: string,
    timeOfEvent: string
	categoryTypes: string[]
	author: string
}

interface IProps {
	resourceArticle: IResourceArticle
	loginState: ILoginState,
	eventDetail?: true
}
export default function ResourceArticle({
	resourceArticle,
	loginState,
	eventDetail,
}: IProps) {
	const { id, heading, updatedDate, dateOfEvent, address, timeOfEvent, author } = resourceArticle

	return (
		<Container padding>
			<div className="grid grid-cols-1 mt-6">
				<div className="w-full flex-col max-w-[1000px] mx-auto">
					<Heading heading={heading} pageId={id} showBookmark={loginState.isLoggedIn} />

					{
						author && (
							<div className='flex items-center text-action-primary-blue-100 text-lg font-bold mt-4'>
								<p className='mb-0'>{author}</p>
								<p className='mx-2 mb-0'>{ author && updatedDate && <div className="w-1 h-1 rounded-full bg-sky-800" /> }</p>
								<p className='mb-0'>{updatedDate}</p>
							</div>
						)
					}

					{/* {
                        updatedDate && !eventDetail &&
                        <p className="text-text-color-80 mt-1">
							Last Updated: {updatedDate}
						</p>
                    }
                    {
                        dateOfEvent && !eventDetail &&
                        <p className="text-text-color-80 mt-1">
                            Event Date: {new Date(dateOfEvent).toJSON().slice(0,10).replace(/-/g,'/')}
						</p>
                    }
                    {
                        dateOfEvent && timeOfEvent && !eventDetail &&
                        <p className="text-text-color-80 -mt-3">
                            Event Time: {timeOfEvent}
						</p>
                    } */}

					{
						eventDetail && (
							<div className='flex flex-wrap w-full mt-4 items-center text-action-primary-blue-100'>
								<div className='flex items-center mr-2'>
									<FontAwesomeIcon icon={faCalendar} className='mr-2' />
									<p className="text-sm font-bold m-0">
										{new Date(dateOfEvent).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
									</p>
									<div className="mx-2 w-1 h-1 rounded-full bg-sky-800" />
									<p className="text-sm font-bold m-0">
										{timeOfEvent}
									</p>
								</div>
								<div className='mr-3 text-border md:block hidden'> | </div>
								<div className='flex items-center md:w-auto w-full md:mt-0 mt-4'>
									<FontAwesomeIcon icon={faLocationDot} className='mr-2' />
									<div className="text-sm font-bold leading-tight">
										{address}
									</div>
								</div>
							</div>
						)
					}


				</div>
				<div className="max-w-[1000px] w-full mx-auto flex flex-wrap gap-1 mt-4">
					{resourceArticle &&
						resourceArticle.categoryTypes.map((categoryType, i) => {
							return (
								<div key={i} className="mr-2 bg-action-primary-blue-100 uppercase rounded-md text-xs py-1 px-2 text-white font-museo">
									{categoryType}
								</div>
							)
						})}
				</div>

				<hr className="mt-12 bg-border/40 h-0.5 border-none"></hr>
			</div>
		</Container>
	)
}
